<template>
    <div>
        <ui-spinner v-if="!modulos"></ui-spinner>
        <template v-else>
            <ul class="list-unstyled">
                <li v-for="modulo in modulos" :key="`modulo_${modulo.idModulo}`">
                    <label class="d-inline-flex align-items-center" :for="`modulo_${modulo.idModulo}`">
                        <input type="checkbox" v-model="modulo.selected" :id="`modulo_${modulo.idModulo}`" @change="onChangeModulo(modulo)">
                        <span class="ml-2 font-weight-bolder">{{ modulo.nombre }}</span>
                    </label>
                    <template v-if="modulo.opciones.length">
                        <ul class="ml-5 list-unstyled">
                            <li v-for="opcion in modulo.opciones" :key="`opcion_${opcion.idItemModulo}`">
                                <label class="d-inline-flex align-items-center" :for="`opcion_${opcion.idItemModulo}`">
                                    <input type="checkbox" v-model="opcion.selected" :id="`opcion_${opcion.idItemModulo}`" @change="onChangeOpcion(modulo)">
                                    <span class="ml-2">{{ opcion.nombre }}</span>
                                </label>
                            </li>
                        </ul>
                    </template>
                </li>
            </ul>
        </template>

    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            modulos: null,
        }
    },
    async created() {
        let vm = this;
        let response = await vm.axios.get('/mantenimiento/usuarios/permisos');
        let modulos = [...response.data.content];
        let permisosActuales = [...vm.value];

        modulos.forEach(modulo => {

            let busquedaModulo = permisosActuales.find(itemPermiso => itemPermiso.guid == modulo.guid)

            modulo.selected = busquedaModulo ? true : false;

            if(modulo.opciones.length) modulo.opciones.forEach(opcion => {
                opcion.selected = busquedaModulo ? busquedaModulo.opciones.indexOf(opcion.guid) !== -1 ? true : false : false;
            })
        });

        vm.modulos = modulos;
    },
    methods: {
        onChangeModulo(pModulo) {
            let itemSelected = pModulo.selected ? true : false;
            pModulo.opciones.forEach(item => {
                item.selected = itemSelected;
            })
            this.updateValue();
        },
        onChangeOpcion(pModulo) {
            let selecteds = pModulo.opciones.filter(item => item.selected);

            if(selecteds.length) pModulo.selected = true;
            else pModulo.selected = false;
            this.updateValue();
        },
        updateValue() {
            let vm = this;
            let tempModulos = [];
            
            vm.modulos.forEach(modulo => {
                let tempModulo = Object.assign({}, { guid: modulo.guid, opciones: modulo.opciones });

                if(modulo.selected) {
                    let tempOpciones = [];

                    tempModulo.opciones.forEach(opcion => {
                        if(opcion.selected) {
                            tempOpciones.push(opcion.guid);
                        }
                    });

                    tempModulo.opciones = tempOpciones;

                    tempModulos.push(tempModulo);
                }
            });

            vm.$emit('input', tempModulos);
        }
    }
}
</script>
